export default __webpack_public_path__ + "alberta-wound-load.20aa224a1c46b3f40e33.svg";